// Warms the browser cache with Power BI's embed scripts/styles so the first report opens faster.
const PRELOAD_EMBED_URL = "https://app.powerbi.com/reportEmbed";
const PRELOAD_DELAY_MS = 3000;
const PRELOAD_IFRAME_LIFETIME_MS = 5000;

let scheduled = false;

export function preloadPowerBI() {
  if (scheduled || typeof window === "undefined") return;
  scheduled = true;

  const run = async () => {
    // A report route is already loading the same assets.
    if (typeof window === "undefined" || window.location.pathname.startsWith("/powerBI")) return;
    try {
      await import("powerbi-client");
      if (typeof window === "undefined") return;
      const iframe = window.powerbi?.preload({ type: "report", embedUrl: PRELOAD_EMBED_URL });
      // Only the cached assets matter; drop the idle iframe so it doesn't hold memory.
      iframe?.addEventListener("load", () => setTimeout(() => iframe.remove(), PRELOAD_IFRAME_LIFETIME_MS), {
        once: true,
      });
    } catch (err) {
      // Preloading is best-effort.
    }
  };

  setTimeout(() => {
    if (typeof window === "undefined") return;
    if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 10000 });
    else run();
  }, PRELOAD_DELAY_MS);
}
